<template>
  <!-- 资质列表 -->
  <div>
    <div class="fourthStep">
      <el-form
        ref="extTable"
        :model="{ extTable }"
        :rules="tableRules"
        props
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
          <div class="table_title">技术人员信息</div>
          <el-table
            border
            :data="extTable"
            class="ccui-form-child-table"
            max-height="99999"
          >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            fixed>
          </el-table-column>
          <el-table-column prop="remark" label="技术类别" width="200px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.categoryType`"
                :rules="tableRules.categoryType"
              >
                <el-select
                  style="width: 180px"
                  v-model="scope.row.categoryType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :disabled="index !== 0 || index !== 1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="personName" label="姓名" width="150px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.personName`"
                :rules="tableRules.personName"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.personName"
                  placeholder="请输入"
                  clearable
                  maxlength="18"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="电话" width="170px">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.phone`"
                  :rules="tableRules.phone"
                >
                  <el-input
                    style="width: 130px"
                    v-model="scope.row.phone"
                    placeholder="请输入"
                    v-input.phoneNum
                    clearable
                    maxlength="25"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="cardType" label="证件类型" width="170px">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.cardType`"
                  :rules="tableRules.cardType"
                >
                  <el-select
                    style="width: 150px"
                    v-model="scope.row.cardType"
                    placeholder="请选择"
                    @change="$forceUpdate()"
                  >
                    <el-option label="身份证" :value="0"></el-option>
                    <el-option label="护照" :value="1"></el-option>
                    <el-option label="其他" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
          <el-table-column prop="idCard" label="证件号码" width="200px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.idCard`"
                :rules="tableRules.idCard"
              >
                <el-input
                  style="width: 180px"
                  v-model="scope.row.idCard"
                  placeholder="请输入"
                  oninput="value=value.replace(/[^0-9a-zA-Z.]/g,'')"
                  clearable
                  maxlength="18"
                />
              </el-form-item>
            </template>
          </el-table-column>
            <el-table-column
              prop="post"
              label="职务"
              width="200px"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.post`"
                  :rules="tableRules.post"
                >
                  <el-input
                    style="width: 180px"
                    v-model="scope.row.post"
                    placeholder="请输入"
                    clearable
                    maxlength="100"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="projectPerformance"
              label="工程业绩"
              width="300px"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.projectPerformance`"
                  :rules="tableRules.projectPerformance"
                >
                  <el-input
                    style="width: 280px"
                    v-model="scope.row.projectPerformance"
                    placeholder="请输入"
                    clearable
                    maxlength="500"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="certificateStatus"
              label="持证情况"
              width="200px"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.certificateStatus`"
                  :rules="tableRules.certificateStatus"
                >
                  <el-input
                    style="width: 180px"
                    v-model="scope.row.certificateStatus"
                    placeholder="请输入"
                    clearable
                    maxlength="500"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="操作" width="100px" fixed="right">
              <template slot-scope="scope">
                <span
                  v-if="scope.$index !== 0 && scope.$index !== 1"
                  style="color: red; cursor: pointer"
                  @click="deleteItem(scope)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+添加人员</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getBuildingGradeDict } from "@/api/subcontractor-register";
export default {
  props: {
    extTable: {
      type: Array,
      default: []
    }
  },
  components: {
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: function(time) {
          return false;
        }
      };
    },
  },
  data() {
    return {
      checkOut:false,
      options: [{
        value: '1',
        label: '专业技术人员'
      }, {
        value: '2',
        label: '特种作业人员'
      }],
      tableRules: {
        categoryType: [{ required: true, message: "请选择技术类别", trigger: "change" }],
        personName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        cardType: [{ required: true, message: "请选择证件类型", trigger: "change" }],

        idCard: [
          { required: true, message: "请输入证件号码", trigger: "blur" }
        ],
        post: [
          { required: true, message: "请输入职务", trigger: "blur" }
        ],
        projectPerformance: [
          { required: true, message: "请输入工程业绩", trigger: "blur" }
        ],
        certificateStatus: [
          { required: true, message: "请输入持证情况", trigger: "blur" }
        ],
      },
    };
  },
  mounted() {
    // getBuildingGradeDict({}).then(res => {
    //   if (res.data.code === "0") {
    //     this.qualificationLevel = res.data.data;
    //   }
    // });
  },
  methods: {
    // categoryTypeChange(val, id){
    //   this.extTable.forEach(item => {
    //     if(item.id == id){
    //       item.categoryType = val.join(",")
    //       item.categoryTypeArray = val
    //     }
    //   })
    //   this.$nextTick(()=> {
    //     this.$forceUpdate()
    //   })
    // },
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1,
          attribute1: "04"
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1,
          attribute1: "04"
        });
      }
    },
    ruleFun() {
      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut=  true;
        } else {
          this.$refs.extTable.$el.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          this.checkOut=  false;
        }
      });
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-table /deep/th.gutter {
  display: table-cell !important;
}
.addBtn {
  cursor: pointer;
  margin: 20px 0px 10px 0px;
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}
/deep/ .el-input--suffix .el-input__inner {
  // padding-right: 25px;
}
/deep/ .el-input__suffix {
  // right: 0px;
  .el-input__clear {
    width: 23px;
  }
}
.addTabIndex /deep/.el-table{
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }

  th>.cell:before{
    content: "*";
    color: red;
    margin-right: 5px;
  }
  th:nth-child(10)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(1)>.cell:before{
    content: "";
    margin-right: 5px;
  }
}
.table_title {
  width: 100%;
  line-height: 40px;
  border: 1px solid #EDF2FC;
  border-bottom: 0px;
  box-sizing: border-box;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #f8fafd;
}
/deep/ .el-select__tags {
  max-width: unset !important;
}
</style>
